<section class="storyblok-blok-container">
  <div
    *ngIf="banner$ | async"
    class="promo-list-header-container"
    test-target="promo-list-header-container"
    appIsVisible
    (isVisible)="fireViewPromoGAEvent()"
  >
    <button
      type="button"
      class="event-button"
      appDisableClickEvent
      (click)="fireSelectPromoGAEvent(); navigateTo()"
      [ngClass]="{'event-button__pointer': !!bannerLink}"
    >
      <img
        class="promo-list-header-container__img"
        [src]="banner$ | async"
        [alt]="'Banner - ' + title"
      >
    </button>
  </div>
</section>
